import { LeasingGroupDto } from './LeasingGroupDto';
import { LeasingTypeEnum } from '../../api/graphql/generated/schema';
import { isMonthlyInstalmentWithinBounds } from '../finance/instalmentValidation';
import { LeasingGroupItemDto } from './LeasingGroupItemDto';
import { leasingContraAccountEnums } from '../../utils/graphGL/graphQLHelper';

// TODO get from config file
const totalKmPerYearOptions = [10000, 15000, 20000, 25000, 30000];

const generateLeasingGroup = (type: LeasingTypeEnum, availableMonths?: Array<number>) => {
  if (availableMonths) {
    let _items: Array<LeasingGroupItemDto> = new Array<LeasingGroupItemDto>();

    availableMonths.forEach((month) => {
      totalKmPerYearOptions.forEach((totalKmPerYear) => {
        _items.push(new LeasingGroupItemDto(month, totalKmPerYear, null));
      });
    });

    return new LeasingGroupDto(type, _items);
  }
  let _items: Array<LeasingGroupItemDto> = new Array<LeasingGroupItemDto>();
  _items.push(new LeasingGroupItemDto(36, 35000, null));
  _items.push(new LeasingGroupItemDto(36, 30000, null));
  _items.push(new LeasingGroupItemDto(36, 25000, null));
  _items.push(new LeasingGroupItemDto(36, 20000, null));
  _items.push(new LeasingGroupItemDto(36, 15000, null));
  _items.push(new LeasingGroupItemDto(36, 10000, null));
  _items.push(new LeasingGroupItemDto(48, 25000, null));
  _items.push(new LeasingGroupItemDto(48, 15000, null));
  _items.push(new LeasingGroupItemDto(48, 10000, null));
  _items.push(new LeasingGroupItemDto(60, 10000, null));

  return new LeasingGroupDto(type, _items);
};

const generateCRNLeasingGroup = (availableMonths?: Array<number>) => {
  return generateLeasingGroup(LeasingTypeEnum.Crn, availableMonths);
};

const generatePhysicalPersonLeasingGroup = (availableMonths?: Array<number>) => {
  return generateLeasingGroup(LeasingTypeEnum.PhysicalPerson, availableMonths);
};

const generateContraAccountCrnLeasingGroup = (availableMonths?: Array<number>) => {
  return generateLeasingGroup(LeasingTypeEnum.ContraAccountCrn, availableMonths);
};

const generateContraAccountPhysicalPersonLeasingGroup = (availableMonths?: Array<number>) => {
  return generateLeasingGroup(LeasingTypeEnum.ContraAccountPhysicalPerson, availableMonths);
};

export const generateLeasingGroupsEmptyStructure = (availableMonths?: Array<number>) => {
  let _leasingGroups: Array<LeasingGroupDto> = new Array<LeasingGroupDto>();
  _leasingGroups.push(generateCRNLeasingGroup(availableMonths));
  _leasingGroups.push(generatePhysicalPersonLeasingGroup(availableMonths));

  return _leasingGroups;
};

export const removeContraAccountGroups = (leasingGroups: Array<LeasingGroupDto>): Array<LeasingGroupDto> => {
  return leasingGroups.filter((item) => !leasingContraAccountEnums.includes(item.type));
};

export const addContraAccountGroups = (
  leasingGroups: Array<LeasingGroupDto>,
  availableMonths?: Array<number>,
): Array<LeasingGroupDto> => {
  const newLeasingGroups: Array<LeasingGroupDto> = [];
  if (!leasingGroups.map((lg) => lg.type).some((lgt) => lgt === LeasingTypeEnum.ContraAccountCrn)) {
    newLeasingGroups.push(generateContraAccountCrnLeasingGroup(availableMonths));
  }
  if (!leasingGroups.map((lg) => lg.type).some((lgt) => lgt === LeasingTypeEnum.ContraAccountPhysicalPerson)) {
    newLeasingGroups.push(generateContraAccountPhysicalPersonLeasingGroup(availableMonths));
  }

  return [...leasingGroups, ...newLeasingGroups];
};

export const isValidMonthlyInstalment = (monthlyInstalment: number | null, mustExists: boolean): boolean => {
  return isMonthlyInstalmentWithinBounds(monthlyInstalment, mustExists, minMonthlyInstalment, maxMonthlyInstalment);
};

export const minMonthlyInstalment: number = 2500;
export const maxMonthlyInstalment: number = 60000;
